var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9481 4.42558C12.9481 6.41394 11.2233 8.10115 8.99997 8.10115C6.77663 8.10115 5.05186 6.41394 5.05186 4.42558C5.05186 2.43721 6.77663 0.75 8.99997 0.75C11.2233 0.75 12.9481 2.43721 12.9481 4.42558Z",
    fill: "#DAFFF0",
    stroke: "#DAFFF0",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.965278 16.0426C1.56471 14.0363 3.44359 11.7303 6.92935 10.8511H11.0724C14.0566 11.3743 16.1021 13.5822 16.8938 15.6922C17.2945 16.7604 17.3386 17.7091 17.118 18.3493C17.0113 18.659 16.8469 18.8883 16.6358 19.047C16.4281 19.2031 16.1338 19.3221 15.7135 19.3469C13.3142 19.3469 11.0545 19.3413 9.07882 19.3364C5.77155 19.3283 3.26005 19.3221 2.22159 19.3471C1.58757 19.3624 1.18455 19.0654 0.953944 18.5352C0.701838 17.9557 0.658834 17.0682 0.965278 16.0426Z",
    fill: "#DAFFF0",
    stroke: "#DAFFF0",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.74cb7bbe418453237412e35ea5e3ce1d.svg";
export { ForwardRef as ReactComponent };